import React from 'react'
import shape from '../../../images/shape/about-glassisom.png'

const About = (props) => {

    return (
        <section className="about">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="da-about-left">
                            <h2 className="title">Smarter IT Solutions, <br/>Seamless Business <br/>Growth</h2>
                            <div className="img"><img src={shape} alt="" /></div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="da-about-right">
                            <p className="content">Unlock your IT ecosystem with TechStr’s ServiceNow solutions, streamlining processes and automating workflows for smarter service delivery.</p>
                            <p className="content">Optimize IT operations, enhance integrations, and drive digital transformation with our seamless, scalable solutions.</p>
                            <p className="content">Boost efficiency, minimize downtime, and build a future-proof IT infrastructure for growth and innovation.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;